export enum CoupaPurchaseType {
    AMOUNT_BASED_LINE = 'OrderAmountLine',
    QUANTITY_BASED_LINE = 'OrderQuantityLine',
}
